<template>
  <b-container>
    <b-row v-loading="loading">
      <div style="margin: 15px 0">
        <router-link :to="{ name : 'CompaniesCreate' }"><b-button variant="dark" size="sm">Firma Ekle</b-button></router-link>
      </div>
      <b-col cols="12" style="margin-bottom:10px">
        <b-card header="Filtreleme" header-tag="header" class="filter-panel">
          <b-row>
              <b-col cols="2">
                  <b-form-group label="Firma ismi">
                    <b-form-input size="sm" v-model="filter.name" placeholder="İsim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="Durum">
                  <b-form-select size="sm" v-model="filter.status" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                    <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                    <b-form-select-option :value="1">Aktif</b-form-select-option>
                    <b-form-select-option :value="0">Pasif</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group style="margin-top:30px">
                  <b-button variant="primary" @click="filterBtn()" style="font-size:12px; margin-right:10px" size="sm">Filtrele</b-button>
                  <b-button variant="danger" @click="clearBtn()" style="font-size:12px" size="sm">Temizle</b-button>
                </b-form-group>
              </b-col>
          </b-row>
        </b-card>
      </b-col>
      <div>
        <div class="table-responsive">
            <table style="table-layout:fixed; font-size:12px;vertical-align: middle;" class="table table-striped table-bordered" v-if="!_.isEmpty(data)">
            <thead>
              <tr>
                <th>ID</th>
                <th>Firma</th>
                <th>Domain</th>
                <th>Firma Url</th>
                <th>İletişim Url</th>
                <th style="width:70px">Durumu</th>
                <th style="width:310px">Detaylar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,key) in data" :key="key">
                <td width="40">{{ item.id }}</td>
                <td>{{ item.title }}</td>
                <td><a :href="item.domain">{{ item.domain }}</a></td>
                <td><a :href="item.client_url">{{ item.client_url }}</a></td>
                <td><a :href="item.contact_url">{{ item.contact_url }}</a></td>
                <td>{{ item.status == "1" ? 'Aktif' : 'Pasif' }}</td>
                <td>
                  <router-link style="margin-right:10px" :to="{ name: 'CompaniesDetailPayment', params: { id : item.id } }"><b-button variant="secondary" style="font-size:12px" size="sm">Ödeme Sistemleri</b-button></router-link>
                  <router-link style="margin-right:10px" :to="{ name: 'CompaniesDetailColor', params: { id : item.id } }">
                    <b-button variant="secondary" style="font-size:12px" size="sm">Renkler</b-button>
                  </router-link>
                  <router-link :to="{ name: 'CompaniesDetail', params: { id : item.id } }"><b-button variant="primary" style="font-size:12px" size="sm">Detaylar</b-button></router-link>
                </td>
              </tr>
            </tbody>
            <div class="block pagination">
              <el-pagination
                  v-if="filter.pageTotal > 0"
                  @size-change="handleSizeChange"
                  @current-change="fetch"
                  :current-page.sync="filter.page"
                  :page-sizes="sizes"
                  :page-size="filter.size"
                  layout="sizes, prev, pager, next"
                  :total="filter.pageTotal"
              ></el-pagination>
            </div> 
          </table>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'CompaniesList',
    data(){
      return{
        sizes: [10, 20, 50, 100],
        loading:false,
        filter:{
          name: null,
          status: null,
          pageTotal: 0,
          size: 10,
          page: 1,
          types: []
        },
        data:[]
      }
    },
    watch:{
        "filter.types": function(val) {
          this.fetch(1, this.filter.size);
        },
    },
    created(){
      this.fetch();
    },
    methods:{
      filterBtn(){
        this.fetch(1, this.filter.size);
      },
      clearBtn(){
        this.filter.name = null;
        this.filter.status = null;
        this.fetch(1, this.filter.size);
      },
      handleSizeChange(value){
        this.filter.size = value;
        this.fetch();
      },
      fetch(page = 1, size = null, silent = false){
        this.filter.page = page;

        if (!_.isNull(size)) 
        {
            this.filter.size = size;
        }
        if(!silent) this.loading = true;
        axios.get('/client',{params: this.filter })
        .then((response) => {
          this.data = response.data.data.data;
          this.filter.pageTotal  	= response.data.data.total;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
    }
  }
</script>